<script lang="ts">
    import DoorOpen from './DoorOpen.svelte';
    import DoorClosed from './DoorClosed.svelte';

    // Wert im Intervall [0, 1]
    // 0: Tür ist zu
    // 1: Tür ist offen
    export let open: number = 0;
    $: degree = -105 * open + 360;
</script>


<div style="width: 100px; height: 140px; position: relative">
    <svg style="position: absolute; left: 0px; top: 0px; width: 80px; height: 140px;">
        <DoorOpen />
    </svg>
    <div style="position: absolute; left: 0px; top: 0px; width: 80px; height: 140px; perspective-origin: 50% 50%; perspective: 500px;  ">
        <svg style="width: 80px; height: 140px; transform: rotateY({degree}deg); background: rgba(210, 0, 0, .7); transform-origin: left;">                
            <DoorClosed />
        </svg>
    </div>
</div>